var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutContainer',{attrs:{"props":_vm.props}},[_c('div',{staticClass:"kaer-image-collapse",style:({
      maxHeight: _vm.maxHeight
    })},[_c('img',{attrs:{"src":_vm.props.src}}),_c('div',{staticClass:"collapse-btn-container",class:!_vm.isCollapse ? 'is-up' : ''},[_c('div',{staticClass:"collapse-btn",style:({
          color: _vm.props.color,
          fontSize: _vm.px2rem(_vm.props.fontSize)
        }),on:{"click":function($event){_vm.isCollapse = !_vm.isCollapse}}},[_vm._v(" "+_vm._s(_vm.isCollapse ? '展开更多' : '收起')+" "),_c('van-icon',{staticClass:"icon-arrow-up",class:_vm.isCollapse ? 'is-down' : '',style:({
            color: _vm.props.color,
            fontSize: _vm.px2rem(_vm.props.fontSize)
          }),attrs:{"name":"arrow-up"}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }